import React from 'react';
import classNames from 'classnames';

type PodcastElementModel = {
  podcast?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const PodcastElement = ({ podcast, className, ...props }: PodcastElementModel) => {
  if (!podcast) {
    return null;
  }

  return (
    <div
      className={classNames('podcast mx-auto my-0 max-h-[305px] w-full max-w-[700px]', className)}
      dangerouslySetInnerHTML={{ __html: podcast }}
      {...props}
    />
  );
};

export default PodcastElement;
